import { View, Text } from "react-native";
import {
  Icon,
  ChevronUpIcon,
  ChevronDownIcon,
  RemoveIcon,
} from "ui/gluestack/icon";

interface Props {
  dependency?: string;
}

const dependencyConfig = {
  low: {
    icon: ChevronDownIcon,
    color: "bg-blue-100",
    textColor: "text-blue-700",
    iconColor: "text-blue-600",
  },
  medium: {
    icon: RemoveIcon,
    color: "bg-orange-100",
    textColor: "text-orange-700",
    iconColor: "text-orange-600",
  },
  high: {
    icon: ChevronUpIcon,
    color: "bg-red-100",
    textColor: "text-red-700",
    iconColor: "text-red-600",
  },
};

export function DependencyIndicator({ dependency }: Props) {
  const normalizedDependency =
    dependency?.toLowerCase() as keyof typeof dependencyConfig;
  const config =
    dependencyConfig[normalizedDependency] || dependencyConfig.medium;

  if (!dependency) {
    return null;
  }

  return (
    <View
      className={`flex-row items-center gap-1 px-2 py-1 rounded-full ${config.color}`}
    >
      <Icon as={config.icon} size="xs" className={config.iconColor} />
      <Text className={`text-xs font-semibold ${config.textColor}`}>
        {dependency?.toUpperCase() || "UNKNOWN"}
      </Text>
    </View>
  );
}
